import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FsErrorResponse, FsOrganisationConsentService } from '@fairandsmart/angular';
import { ProcessingQuery, ProcessingQueryResult } from '@fairandsmart/types';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AlertService } from '@Services/alert.service';
import { OrgaService } from '@Services/orga.service';
import { ProcessingQueryDialogComponent } from './processing-query-dialog/processing-query-dialog.component';

@Injectable()
export class ProcessingService {
  private orgaService = inject(OrgaService);

  private fsOrganisationConsentService = inject(FsOrganisationConsentService);

  private alert = inject(AlertService);

  private dialog = inject(MatDialog);

  deleteProcessing(processingId: string): Observable<boolean> {
    return this.alert.promptConfirmDialog({
      data: {
        title: 'TREATMENT.PROMPT_DELETE.TITLE',
        content: 'TREATMENT.PROMPT_DELETE.MESSAGE',
        confirm: 'COMMON.BUTTONS.CONFIRM',
      },
    }).afterClosed().pipe(
      mergeMap((confirmed: boolean) => {
        if (confirmed) {
          return this.fsOrganisationConsentService.deleteProcessing(this.orgaService.id, processingId).pipe(
            map(() => {
              this.alert.success('TREATMENT.PROMPT_DELETE.SUCCESS');
              return true;
            }),
          );
        }
        return of(false);
      }),
      catchError((response: FsErrorResponse) => {
        this.alert.apiError(response.error, 'TREATMENT.PROMPT_DELETE.ERROR', { timeOut: 10000 });
        return of(false);
      }),
    );
  }

  searchProcessings(orgaid: string, key: string): void {
    this.dialog.open(ProcessingQueryDialogComponent, {
      data: {
        service: this as ProcessingService,
        orgaid,
        key,
      },
    });
  }

  queryProcessings(query: ProcessingQuery): Observable<ProcessingQueryResult> {
    return this.fsOrganisationConsentService.queryProcessingAllowed(this.orgaService.id, query);
  }
}
